import { createSlice } from "@reduxjs/toolkit";

const trackhrcategoryslice = createSlice({
  name: "trackhrcategory",
  initialState: {
  activeCategoryDataArr: {},
  CategoryDataArr: {},
    loading: false
  },
  reducers: {
   setTrackHRDataCategory: (state, action) => {
  if (action.payload.activeCategoryDataArr)
    state.activeCategoryDataArr = action.payload.activeCategoryDataArr;
  if (action.payload.CategoryDataArr)
    state.CategoryDataArr = action.payload.CategoryDataArr;
},
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const { setTrackHRDataCategory, setLoading } = trackhrcategoryslice.actions;
export default trackhrcategoryslice.reducer;
